import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  authenticated() {
    return RequesterV1.get("security/is_user_authenticated");
  },
  authorized(role, permission, entity) {
    return RequesterV1.post(
      `security/is_user_authorized/${role}/${permission}`,
      { entity }
    );
  }
};
